import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { buildQueryParams } from '@/utils/routeHelpers'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useReselector } from '@/utils/sharedHooks'
import {
  selectStatusForTaxEstimate,
  selectUserTaxEstimateById,
} from '../../userTaxEstimates.selector'
import { Button } from '@/ui'
import { EstimateStatus } from '../../service'
import { UserTaxEstimate } from '../../userTaxEstimates.slice'
import { selectIsSingleStateCalculationByTaxEstimateId } from '@/selectors/userTaxCalculation.selectors'
import useTaxPaymentInfoFlyout from '../TaxPaymentInfoFlyout'
import { fetchUserDocuments } from '@/features/user/your-practice/documents/lib/userDocuments.slice'

// TODO: Migrate to V2 skipcq: JS-0099
import UpdateQuarterlyTaxEstimateModal from '@/featuresV1/Taxes/QuarterlyTaxEstimates/components/UpdateQuarterlyTaxEstimateModal'

export const createLinkToTaxBreakdown = (
  estimate: UserTaxEstimate | null,
  queryParams?: Parameters<typeof buildQueryParams>[0]
) =>
  `/taxes/quarterly/${estimate?.taxQuarter}/estimate-breakdown?section=${estimate?.type === 'federal' ? 'federal' : 'state'}${queryParams ? `&${buildQueryParams(queryParams)}` : ''}`

export const TaxEstimateCta = ({ estimateId }: { estimateId?: number }) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const estimate = useReselector(selectUserTaxEstimateById, estimateId)
  const status = useReselector(selectStatusForTaxEstimate, estimateId)
  const isSingleStateCalc = useReselector(
    selectIsSingleStateCalculationByTaxEstimateId,
    estimateId
  )
  const [modalOpen, setModalOpen] = useState(false)

  const openFlyout = useTaxPaymentInfoFlyout({
    estimateId,
    openQTEModal: () => setModalOpen(true),
  })

  useEffect(() => {
    dispatch(fetchUserDocuments())
  }, [dispatch])

  const isFederal = estimate?.type === 'federal'

  return (
    <div className="w-full flex flex-wrap items-center gap-4 mt-2">
      {(status === EstimateStatus.upcoming ||
        status === EstimateStatus.paid ||
        status === EstimateStatus.joinedTooLate ||
        status === EstimateStatus.unpaidWithResponse) && (
        <div className="w-full flex justify-start">
          <Button onClick={() => setModalOpen(true)} variant="secondary">
            Update Payment
          </Button>
        </div>
      )}

      {(status === EstimateStatus.readyForPayment ||
        status === EstimateStatus.estimateIsZero) &&
        (isFederal && isSingleStateCalc ? (
          <div className="w-full sm:w-1/2">
            <Button
              onClick={() => navigate(createLinkToTaxBreakdown(estimate))}
            >
              {status === EstimateStatus.estimateIsZero
                ? 'View Details'
                : 'View Details & Pay'}
            </Button>
          </div>
        ) : (
          <>
            <Button className="w-full sm:w-1/4" onClick={openFlyout}>
              View & Pay
            </Button>
            <Button
              className="w-full sm:w-1/4"
              onClick={() => setModalOpen(true)}
              variant="secondary"
            >
              Mark as Paid
            </Button>
          </>
        ))}

      {status === EstimateStatus.unpaidWithoutResponse && (
        <>
          <div className="hidden sm:block sm:w-3/4" />
          <Button
            className="w-full sm:w-1/4 flex"
            onClick={() => setModalOpen(true)}
          >
            Update Payment
          </Button>
        </>
      )}

      {estimate && (
        <UpdateQuarterlyTaxEstimateModal
          open={modalOpen}
          close={() => setModalOpen(false)}
          estimate={estimate}
        />
      )}
    </div>
  )
}
